import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Setting } from '../../../models/setting';
import { environment } from '../../../../environments/environment';

@Injectable({
    providedIn: 'root'
})
export class SettingsService {

    constructor(private http: HttpClient) {
    }

    write(id: string, value: any): Observable<Setting> {
        return this.http.put<Setting>(`${environment.apiUrl}/settings/${id}`, { id, value });
    }

    read(id: string): Observable<Setting> {
        return this.http.get<Setting>(`${environment.apiUrl}/settings/${id}`);
    }

}
